import 'process';

import Keycloak from 'keycloak-js';

const keycloakConfig = {
  clientId: import.meta.env.VITE_APP_KEYCLOAK_RESOURCE || 'ks-react-client',
  publicClient: true,
  realm: import.meta.env.VITE_APP_KEYCLOAK_REALM || 'development',
  sslRequired: import.meta.env.VITE_APP_KEYCLOAK_SSL_REQUIRED || 'external',
  url:
    import.meta.env.VITE_APP_KEYCLOAK_URL ||
    'https://auth.kandasearch.com/auth/',
};

export const keycloak = new Keycloak(keycloakConfig);
export const initOptions = { pkceMethod: 'S256' };
